import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaCargaHorariaProfessorAnalitico(props) {
    const { estrutura } = props;
    const { professores } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Professores",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Data',
                    accessor: 'data',
                },
                {
                    Header: 'Tipo de Atividade',
                    accessor: 'tipo_atividade',
                },
                {
                    Header: 'Aula',
                    accessor: 'atividade',
                },
                {
                    Header: 'Carga Horária',
                    accessor: 'carga_horaria',
                },
                {
                    Header: 'Módulo',
                    accessor: 'modulo_nome',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"
            {...props}
        >
            <Tabela
                columns={columns}
                data={professores}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaCargaHorariaProfessorAnalitico;
